import React from 'react';
import MaterialIcon from "react/elements/MaterialIcon";


export default function RolloverIcon(){
	return <span title="Budget Rolled Over" className="money neutral"><MaterialIcon>cached</MaterialIcon></span>
}